<template>
  <div class="report-summary-header">
    <h3 class="b-bold">Reported Items</h3>

    <h3>
      Total Units:
      {{ formatNumber(data.reported_sum_of_units) }}
    </h3>

    <h3>
      Total Weight:
      {{ formatNumber(data.reported_sum_of_weight) }}
      Kg
    </h3>

    <h3 v-if="showUpliftedUnits">
      Total Uplifted Units:
      {{ formatNumber(data.uplifted_reported_sum_of_units) }}
    </h3>

    <h3 v-if="showUpliftedWeight">
      Total Uplifted Weights:
      {{ formatNumber(data.uplifted_reported_sum_of_weight) }}
      Kg
    </h3>

    <h3>
      Total Fee:
      {{ formatFee }}
      {{ data.currency }}
    </h3>
  </div>
</template>

<script>
export default {
  name: "ReportSummaryHeader",
  props: {
    data: {
      type: Object,
      required: true
    },
    upliftApplied: {
      type: Boolean,
      default: false
    },
    upliftType: {
      type: String,
      default: null
    },
    tdWithoutPd: {
      type: String,
      default: "TD_WITHOUT_PD"
    }
  },
  computed: {
    showUpliftedUnits() {
      return this.upliftApplied && this.upliftType === this.tdWithoutPd;
    },
    showUpliftedWeight() {
      return this.upliftApplied && this.upliftType;
    },
    formatFee() {
      const fee =
        this.data.sum_final_uplifted_fee || this.data.final_total_fee || 0;
      return this.formatNumber(fee) + " *";
    }
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "0";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>

<style scoped>
.report-summary-header {
  background-color: #fafafa;
  padding: 1rem;
  border-radius: 0px;
  margin-bottom: 1rem;
  border: 1px solid #dbdbdb;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
}

.report-summary-header h3 {
  padding-bottom: 0;
  margin-bottom: 0;
}

.b-bold {
  font-weight: 900;
  color: #363636;
}
</style>
